import * as React from "react";

import { StyleRules, Theme, withStyles } from "@material-ui/core/styles";
import {WithStyles} from "@material-ui/core/styles/withStyles";

import {Text, TextInput} from "../components";

import CoffeeIconSmall from "./CoffeeIconSmall";
import Coffees from "./Coffees";

type ClassNames = "container" | "image" | "times" | "selection";

const styles = (theme: Theme): StyleRules<ClassNames> => ({
  container: {
    borderColor: theme.palette.primary[500],
    backgroundColor: "rgba(68, 151, 236, 0.1)",
    borderWidth: 1,
    borderStyle: "solid",
    padding: theme.spacing.unit * 2,
    borderRadius: 5,
    display: "flex",
    justifyContent: "center",
    boxSizing: "border-box",
    marginBottom: theme.spacing.unit * 2
  },
  image: {
    height: 50
  },
  times: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    alignSelf: "center"
  },
  selection: {
    marginTop: 0,
    width: 40,
    backgroundColor: "white"
  }
});

interface ICoffeeSelectionProps extends WithStyles<typeof styles>  {
  onChange: (selectionValue: string, selection: number) => void;
  selection: number;
  selectionValue: string;
}

class CoffeeSelection extends React.PureComponent<ICoffeeSelectionProps> {
  
  public onChange = (selection: string) => {
    const value = parseInt(selection, 10);
    this.props.onChange(selection, isNaN(value) ? 0 : value);
  };

  public render() {
    const {onChange} = this;
    const {classes, selection, selectionValue} = this.props;
    return (
      <div className={classes.container}>
        <CoffeeIconSmall />
        <Text className={classes.times} gutterBottom={false}>x</Text>
        <TextInput
          placeholder="1"
          value={selectionValue}
          type="number"
          onChange={this.onChange}
          className={classes.selection}
        />
        {
          [1, 3, 5].map(n => (
            <Coffees
              key={n}
              selection={n}
              isSelected={selection === n}
              {...{onChange}}
            />
          ))
        }
      </div>
    );
  }
}

export default withStyles(styles)(CoffeeSelection);


// WEBPACK FOOTER //
// ./src/buy-me-a-coffee/CoffeeSelection.tsx